import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {Flex, Box} from 'reflexbox';
import {inject, observer} from 'mobx-react';

import {Card, CardTitle, CardText, Slider} from 'react-md';
import {Button} from "react-bootstrap";

@inject('EventStore')
export class RegisterFailCard extends Component {
    constructor(props) {
        super(props);

    }

    componentDidMount() {

    }

    handlerBackClick() {
        this.props.EventStore.reInit();
    }

    getErrorMessage() {
        const {result} = this.props;
        if (result) {
            const {data} = result;
            if (data.code == 10) {
                return `${data.member.name} ได้ลงทะเบียนแล้ว`
            }
        }


        // if (result.)
    }

    render() {
        return (
            <Card className='reg-card md-block-centered'>
                <CardTitle title='ลงทะเบียนล้มเหลว'/>
                <CardText>
                    <Flex column>
                        <h4>{this.getErrorMessage()}</h4>
                        <span>กรุณาลองอีกครั้ง หรือ ติดต่อเจ้าหน้าที่ลงทะเบียน</span>
                        <Button
                            type='button'
                            bsStyle='primary'
                            onClick={this.handlerBackClick.bind(this)}
                            style={{marginTop: 24}}
                        >
                            ลงทะเบียนอีกครั้ง
                        </Button>
                    </Flex>
                </CardText>
            </Card>

        );
    }
}

export default RegisterFailCard;



// WEBPACK FOOTER //
// ./src/component/event/RegisterFail.jsx